<ng-template #showFullscreenTemplate>
	<b><a (click)="toggleFullscreen()"><i nz-icon nzType="eye"></i> Fullscreen</a></b>
</ng-template>
<nz-card nzTitle="Ablenkungsfreier Wizard" [nzExtra]="showFullscreenTemplate">
<div class="showcase-distraction-free-container" [ngClass]="{'with-fullscreen': isFullscreen}">

<div class="distractionFreeWizard" *ngIf="workflow" [appWorkflowItem]="workflowItem" [appWorkflowItemData]="item">
	<form nz-form *ngIf="page">
		<div nz-row class="topbar" [nzGutter]="[16,6]">
			<div nz-col nzSpan="2">
				<!-- Wizard verlassen -->
				<button *ngIf="!workflowItem.showOverview"
						nz-button nzType="secondary" type="button" class="big-back-button"
						(click)="toggleFullscreen()"
				>
					<i nz-icon nzType="close"></i>
				</button>
				<!-- Zur Fragebogenübersicht -->
				<button *ngIf="workflowItem.showOverview"
						nz-button nzType="secondary" type="button" class="big-back-button"
				>
					<i nz-icon nzType="close"></i>
				</button>
			</div>
			<div nz-col nzSpan="22">
				<h2 class="big-title">{{ pageId+1 }}. {{ page.question?.title }}</h2>
			</div>
		</div>
		<div nz-row class="descriptionBox">
			<div nz-col nzOffset="2" nzSpan="20">
				<div markdown class="markdown big-text" [data]="page.question?.description"></div>
			</div>
		</div>
		<div nz-row class="wizardContent height-100" nzJustify="space-around" nzAlign="middle">
			<div nz-col nzSpan="9">
				<div class="big-question center">
					<ng-container [ngSwitch]="page.question?.type">
						<workflow-questionnaire-block-question *ngSwitchCase="'BlockQuestion'"
														[question]="page.question">
						</workflow-questionnaire-block-question>
						<workflow-special-question *ngSwitchCase="'LandoltTest'"
														[question]="page.question" [currentPage]="page.subpage" [isWizard]="true">
						</workflow-special-question>
						<ng-container *ngSwitchCase="'prolog'"></ng-container>
						<ng-container *ngSwitchCase="'preface'"></ng-container>
						<ng-container *ngSwitchCase="'epilog'"></ng-container>
						<div *ngSwitchDefault>
							Unbekannter Typ: {{ page.question?.type }}
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</form>
	<div nz-row class="wizardButtons bottomrow">
		<div nz-col nzSpan="2">
			<!--Zurück für einzelne Fragen-->
			<button *ngIf="hasPreviousPage" nz-button nzType="primary" (click)="setPage(pageId-1)" class="big-button"><i nz-icon nzType="left"></i>
				{{ 'actions.back' | translate }}
			</button>
		</div>
		<div nz-col nzSpan="2" nzOffset="19">
			<!--Vorwärts für Seiten einzelner Fragen-->
			<button *ngIf="hasNextPage" nz-button nzType="primary" (click)="setPage(pageId+1)" class="big-button right-one">
				{{ 'actions.next' | translate }}<i nz-icon nzType="right"></i>
			</button>
			<button *ngIf="!hasNextPage" nz-button nzType="primary" class="big-button right-one">
				{{ 'workflow.end' | translate }}<i nz-icon nzType="right"></i>
			</button>
		</div>
	</div>
</div>

</div>
</nz-card>
